var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "search-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.queryParams },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择类型",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.queryParams.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "type", $$v)
                        },
                        expression: "queryParams.type",
                      },
                    },
                    _vm._l(_vm.enumTypes, function (item) {
                      return _c("el-option", {
                        key: item.type,
                        attrs: { label: item.typeName, value: item.type },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "请求状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择请求状态", clearable: "" },
                      model: {
                        value: _vm.queryParams.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "status", $$v)
                        },
                        expression: "queryParams.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "成功", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "失败", value: -1 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "时间范围" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleQuery },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "table-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.logList,
                border: "",
                "empty-text": "暂无数据",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  width: "100",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "logType",
                  label: "类型名称",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getTypeName(scope.row.logType))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dataId",
                  label: "数据ID",
                  "min-width": "140",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "logFrom",
                  label: "请求方",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "logTo",
                  label: "被请求方",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "logStatus",
                  label: "请求状态",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStatusTagType(scope.row.logStatus),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getStatusText(scope.row.logStatus)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "请求时间",
                  width: "180",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.formatDateTime(scope.row.createTime))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("\n            详情\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.total > 0
            ? _c("el-pagination", {
                staticStyle: { "margin-top": "20px", "text-align": "right" },
                attrs: {
                  "current-page": _vm.queryParams.page,
                  "page-size": _vm.queryParams.limit,
                  total: _vm.total,
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100],
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.detailTitle,
            visible: _vm.detailVisible,
            width: "80%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 2, border: "" } },
            [
              _c("el-descriptions-item", { attrs: { label: "ID" } }, [
                _vm._v(_vm._s(_vm.logDetail.id)),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "类型" } }, [
                _vm._v(_vm._s(_vm.getTypeName(_vm.logDetail.logType))),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "数据ID" } }, [
                _vm._v(_vm._s(_vm.logDetail.dataId)),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "请求时间" } }, [
                _vm._v(_vm._s(_vm.formatDateTime(_vm.logDetail.createTime))),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "请求方" } }, [
                _vm._v(_vm._s(_vm.logDetail.logFrom)),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "被请求方" } }, [
                _vm._v(_vm._s(_vm.logDetail.logTo)),
              ]),
              _vm._v(" "),
              _c(
                "el-descriptions-item",
                { attrs: { label: "请求状态" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getStatusTagType(_vm.logDetail.logStatus),
                        size: "small",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getStatusText(_vm.logDetail.logStatus)) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "detail-section" },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("请求参数")]),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "detail-textarea",
                attrs: { type: "textarea", rows: 8, readonly: "" },
                model: {
                  value: _vm.logDetail.logData,
                  callback: function ($$v) {
                    _vm.$set(_vm.logDetail, "logData", $$v)
                  },
                  expression: "logDetail.logData",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "detail-section" },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("请求结果")]),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "detail-textarea",
                attrs: { type: "textarea", rows: 12, readonly: "" },
                model: {
                  value: _vm.logDetail.logResult,
                  callback: function ($$v) {
                    _vm.$set(_vm.logDetail, "logResult", $$v)
                  },
                  expression: "logDetail.logResult",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }